import { useEffect, useState, useCallback } from "react";
import { PatternFormat } from "react-number-format";
import { useForm, Controller } from "react-hook-form";
import { Select } from "react-functional-select";
import toast from "react-hot-toast";
import axios from "axios";
import AydinlatmaMetni from "./AydinlatmaMetni";

const CustomFormError = ({ children }) => (
  <span
    style={{
      width: "100%",
      marginTop: "0.25rem",
      fontSize: "0.875em",
      fontWeight: "600",
      color: "red",
    }}
  >
    {children}
  </span>
);

const ApplicationForm = () => {
  const {
    control,
    handleSubmit,
    register,
    // reset,
    // clearErrors,
    // setError,
    // unregister,
    // getValues,
    // setValue,
    // getFieldState,
    watch,
    formState: { errors, isSubmitting },
  } = useForm({
    mode: "all",
  });

  const [universities, setUniversites] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [iclass, setClass] = useState([]);
  const [uploading, setUploading] = useState(false);

  const getFilterOptionString = useCallback(
    (menuOption) => menuOption.data.value.toLocaleLowerCase("tr"),
    []
  );

  const fetchUniversites = () => {
    const url = "https://api.webeyondcreative.com/api/form/university";
    const token =
      "eyJhbGciOiJIUzI1NiIsInR5cCI6Ikp6XVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIi5wibmFtZSI6Ikpva2G4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c";
    axios
      .get(url, {
        headers: {
          "X-Api-Token": token,
        },
      })
      .then((response) => {
        const universities = response.data;
        setUniversites(
          universities.map((university) => ({
            value: university.name,
            label: university.name,
          }))
        );
      });
  };
  const fetchDepartments = () => {
    const url = "https://api.webeyondcreative.com/api/form/department";
    const token =
      "eyJhbGciOiJIUzI1NiIsInR5cCI6Ikp6XVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIi5wibmFtZSI6Ikpva2G4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c";
    axios
      .get(url, {
        headers: {
          "X-Api-Token": token,
        },
      })
      .then((response) => {
        const departments = response.data;
        setDepartments(
          departments.map((department) => ({
            value: department.name,
            label: department.name,
          }))
        );
      });
  };
  const fetchClasses = () => {
    const url = "https://api.webeyondcreative.com/api/form/class";
    const token =
      "eyJhbGciOiJIUzI1NiIsInR5cCI6Ikp6XVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIi5wibmFtZSI6Ikpva2G4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c";
    axios
      .get(url, {
        headers: {
          "X-Api-Token": token,
        },
      })
      .then((response) => {
        const classes = response.data;
        setClass(
          classes.map((iclass) => ({
            value: iclass.name,
            label: iclass.name,
          }))
        );
      });
  };

  const submitForm = (data) => {
    // console.log(data);
    setUploading(true);
    axios.defaults.headers["X-Api-Token"] =
      "eyJhbGciOiJIUzI1NiIsInR5cCI6Ikp6XVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIi5wibmFtZSI6Ikpva2G4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c";
    axios.defaults.headers["Access-Control-Allow-Origin"] = "*";
    axios.defaults.headers["Access-Control-Allow-Credentials"] = "true";

    const formData = new FormData();
    ["department", "university", "class"].forEach((item) => {
      data[item] = data[item].value;
    });

    for (const [key, value] of Object.entries(data)) {
      formData.append(key, value);
    }

    // for (const value of formData.values()) {
    //   console.log(value);
    // }

    axios
      .post(
        "https://api.webeyondcreative.com/api/form/store/we_mtstaj_2023",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
      .then((response) => {
        if (response.data.exists === "success") {
          setUploading(false);
          toast.success("Başvurunuz alındı. İlginiz için teşekkürler.");
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        } else if (response.data.exists === "db_error") {
          setUploading(false);
          toast.error("Başvurunuz alınamadı!!");
        } else if (response.data.errors.email) {
          setUploading(false);
        }
      })
      .catch((error) => {
        setUploading(false);
        toast.error("Bu e-posta adresi ile daha önce başvuru yapılmıştır!");
        console.log(error);
      });
  };

  useEffect(() => {
    fetchUniversites();
    fetchDepartments();
    fetchClasses();
  }, []);

  return (
    <section
      id="kayit-ol"
      className="w-full flex justify-center bg-[#244C5A] py-24"
    >
      <div className="w-4/5 lg:w-4/6 max-w-screen-xl space-y-10">
        <div className="flex flex-col items-center space-y-2">
          <h4
            data-aos="fade-down"
            style={{ fontFamily: "Gotham" }}
            className="text-white  text-3xl lg:text-[81px] font-bold leading-none"
          >
            KAYIT OL VE
          </h4>
          <h4
            data-aos="fade-right"
            style={{ fontFamily: "Gotham" }}
            className="bg-[url('../../assets/images/application-form-title-bg.png')] text-3xl lg:text-[82px] text-[#244C5A] font-bold leading-none py-3 px-11 bg-center bg-contain bg-no-repeat"
          >
            SORU SOR!
          </h4>
        </div>
        <div>
          <form onSubmit={handleSubmit(submitForm)} className="space-y-5">
            <div className="form-group flex flex-col lg:flex-row">
              <div className="w-full lg:w-1/5 flex items-center h-[52px]">
                <label
                  style={{ fontFamily: "Poppins" }}
                  className="text-[23px] text-white font-semibold"
                  htmlFor="fullname"
                >
                  Ad & Soyad
                </label>
              </div>
              <div className="w-full lg:w-4/5">
                <input
                  {...register("fullname", {
                    required: "Bu alan zorunlu!",
                  })}
                  type="text"
                  style={{ boxShadow: "none" }}
                  className="form-control block rounded-none w-full h-[52px] px-3 py-3  font-normal text-white text-xl bg-transparent bg-clip-padding transition ease-in-out m-0 focus:text-white focus:bg-white focus:outline-none border-[3px] border-[#DB725A]"
                  id="fullname"
                  aria-describedby="fullname"
                  placeholder=""
                />
                <CustomFormError>{errors.fullname?.message}</CustomFormError>
              </div>
            </div>
            <div className="form-group flex flex-col lg:flex-row">
              <div className="w-full lg:w-1/5 flex items-center h-[52px]">
                <label
                  style={{ fontFamily: "Poppins" }}
                  className="text-[23px] text-white font-semibold"
                  htmlFor="email"
                >
                  E-Posta
                </label>
              </div>
              <div className="w-full lg:w-4/5">
                <input
                  {...register("email", {
                    required: "Bu alan zorunlu!",
                    pattern: {
                      value: /\S+@\S+\./,
                      message: "Yanlış e-posta formatı!",
                    },
                  })}
                  type="email"
                  style={{ boxShadow: "none" }}
                  className="form-control block rounded-none w-full h-12 px-3 py-3  font-normal text-white text-xl bg-transparent bg-clip-padding transition ease-in-out m-0 focus:text-white focus:bg-transparent focus:outline-none lowercase placeholder:normal-case border-[3px] border-[#DB725A]"
                  id="email"
                  aria-describedby="email"
                  placeholder=""
                />
                <CustomFormError>{errors.email?.message}</CustomFormError>
              </div>
            </div>
            <Controller
              control={control}
              name="phone"
              rules={{
                required: "Bu alan zorunlu!",
              }}
              render={({
                field: { onChange, onBlur, value, name, ref },
                fieldState: { error },
              }) => (
                <div className="form-group flex flex-col lg:flex-row">
                  <div className="w-full lg:w-1/5 flex items-center h-[52px]">
                    <label
                      style={{ fontFamily: "Poppins" }}
                      className="text-[23px] text-white font-semibold"
                      htmlFor="phone"
                    >
                      Telefon
                    </label>
                  </div>
                  <div className="w-full lg:w-4/5">
                    <PatternFormat
                      name={name}
                      getInputRef={ref}
                      onChange={onChange}
                      onBlur={onBlur}
                      value={value}
                      disabled={isSubmitting}
                      style={{ boxShadow: "none" }}
                      className="form-control block rounded-none w-full h-12 px-3 py-3 text-xl font-normal text-white bg-transparent bg-clip-padding transitions ease-in-out m-0 focus:text-white focus:bg-transparent focus:outline-none border-[3px] border-[#DB725A]"
                      placeholder=""
                      format="0 ### ### ## ##"
                      mask="_"
                    />
                    <CustomFormError>{error && error.message}</CustomFormError>
                  </div>
                </div>
              )}
            />
            <div className="flex flex-col lg:flex-row">
              <div className="w-full lg:w-1/5 flex items-center h-[52px]">
                <label
                  style={{ fontFamily: "Poppins" }}
                  className="text-[23px] text-white font-semibold"
                  htmlFor="university"
                >
                  Üniversite
                </label>
              </div>
              <div className="w-full lg:w-4/5 flex flex-col lg:flex-row">
                <Controller
                  control={control}
                  name="university"
                  rules={{
                    required: "Bu alan zorunlu!",
                  }}
                  render={({
                    field: { onChange, onBlur, value, name, ref, id },
                    fieldState: { error },
                  }) => (
                    <div
                      className="form-group w-full lg:w-1/4"
                      aria-invalid={!!error}
                    >
                      <Select
                        id={id}
                        ref={ref}
                        name={name}
                        isClearable
                        options={universities}
                        themeConfig={{
                          control: {
                            backgroundColor: "transparent",
                            borderRadius: 0,
                            height: "52px",
                            boxShadow: "none",
                          },
                        }}
                        placeholder="Seçiniz"
                        onOptionChange={onChange}
                        onInputBlur={onBlur}
                        value={value}
                        filterIgnoreAccents={true}
                        getFilterOptionString={getFilterOptionString}
                      />
                      <CustomFormError>
                        {error && error.message}
                      </CustomFormError>
                    </div>
                  )}
                />
                <div className="w-full lg:w-1/6 flex items-center h-[52px] justify-start lg:justify-end lg:pr-5 mt-5 lg:mt-0">
                  <label
                    style={{ fontFamily: "Poppins" }}
                    className="text-[23px] text-white font-semibold"
                    htmlFor="department"
                  >
                    Bölüm
                  </label>
                </div>
                <Controller
                  control={control}
                  name="department"
                  rules={{
                    required: "Bu alan zorunlu!",
                  }}
                  render={({
                    field: { onChange, onBlur, value, name, ref, id },
                    fieldState: { error },
                  }) => (
                    <div
                      className="form-group w-full lg:w-1/4"
                      aria-invalid={!!error}
                    >
                      <Select
                        id={id}
                        ref={ref}
                        name={name}
                        isClearable
                        options={departments}
                        themeConfig={{
                          control: {
                            backgroundColor: "transparent",
                            borderRadius: 0,
                            height: "52px",
                            boxShadow: "none",
                          },
                        }}
                        placeholder="Seçiniz"
                        onOptionChange={onChange}
                        onInputBlur={onBlur}
                        value={value}
                      />
                      <CustomFormError>
                        {error && error.message}
                      </CustomFormError>
                    </div>
                  )}
                />
                <div className="w-full lg:w-1/6 flex items-center h-[52px] justify-start lg:justify-end lg:pr-5 mt-5 lg:mt-0">
                  <label
                    style={{ fontFamily: "Poppins" }}
                    className="text-[23px] text-white font-semibold"
                    htmlFor="class"
                  >
                    Sınıf
                  </label>
                </div>
                <Controller
                  control={control}
                  name="class"
                  rules={{
                    required: "Bu alan zorunlu!",
                  }}
                  render={({
                    field: { onChange, onBlur, value, name, ref, id },
                    fieldState: { error },
                  }) => (
                    <div
                      className="form-group w-full lg:w-1/4"
                      aria-invalid={!!error}
                    >
                      <Select
                        id={id}
                        ref={ref}
                        name={name}
                        isClearable
                        options={iclass}
                        themeConfig={{
                          control: {
                            backgroundColor: "transparent",
                            borderRadius: 0,
                            height: "52px",
                            boxShadow: "none",
                          },
                        }}
                        placeholder="Seçiniz"
                        onOptionChange={onChange}
                        onInputBlur={onBlur}
                        value={value}
                      />
                      <CustomFormError>
                        {error && error.message}
                      </CustomFormError>
                    </div>
                  )}
                />
              </div>
            </div>
            <div className="form-group flex flex-col lg:flex-row">
              <div className="w-full lg:w-1/5 flex items-center lg:items-start min-h-[52px]">
                <label
                  style={{ fontFamily: "Poppins" }}
                  className="text-[23px] text-white font-semibold"
                  htmlFor="asksomething"
                >
                  Şirketlere ne sormak istersin?
                </label>
              </div>
              <div className="w-full lg:w-4/5">
                <textarea
                  {...register("asksomething", {
                    required: "Bu alan zorunlu!",
                  })}
                  style={{ boxShadow: "none" }}
                  className="form-control block rounded-none w-full h-[118px] min-h-[118px] max-h-[200px] px-3 py-3  font-normal text-white text-xl bg-transparent bg-clip-padding transition ease-in-out m-0 focus:text-white focus:bg-white focus:outline-none border-[3px] border-[#DB725A]"
                  id="asksomething"
                  aria-describedby="asksomething"
                  placeholder=""
                />
                <CustomFormError>
                  {errors.asksomething?.message}
                </CustomFormError>
              </div>
            </div>
            <div className="flex flex-col lg:items-end">
              <div className="form-group w-full lg:w-4/5 flex flex-row items-center">
                <input
                  {...register("aydinlatmaMetni", {
                    required: "Bu alan zorunlu!",
                  })}
                  type="checkbox"
                  className="form-check-input appearance-none h-4 w-4 min-w-[16px] border border-gray-300 rounded-sm bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 align-top bg-no-repeat bg-center bg-contain mr-1 cursor-pointer"
                  id="aydinlatma-metni"
                />
                <p
                  style={{ fontFamily: "Poppins" }}
                  className={
                    errors.aydinlatmaMetni
                      ? "text-red-500 pl-2 text-sm uppercase"
                      : "text-white pl-2 text-sm uppercase"
                  }
                >
                  <span
                    data-bs-toggle="modal"
                    data-bs-target="#aydinlatmaMetni"
                    className="underline cursor-pointer"
                  >
                    AYDINLATMA METNİ
                  </span>
                  ’Nİ OKUDUM VE KAYIT KOŞULLARINI KABUL EDİYORUM.
                </p>
                <AydinlatmaMetni isChecked={watch("aydinlatmaMetni")} />
              </div>
              <div className="form-group w-full lg:w-4/5 flex flex-row items-start mt-2">
                <input
                  {...register("useofpersonaldata", {
                    required: "Bu alan zorunlu!",
                  })}
                  type="checkbox"
                  className="form-check-input appearance-none h-4 w-4 min-w-[16px] mt-1 border border-gray-300 rounded-sm bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 align-top bg-no-repeat bg-center bg-contain mr-1 cursor-pointer"
                  id="useofpersonaldata"
                />
                <p
                  style={{ fontFamily: "Poppins" }}
                  className={
                    errors.useofpersonaldata
                      ? "text-red-500 pl-2 text-sm uppercase"
                      : "text-white pl-2 text-sm uppercase"
                  }
                >
                  Aydınlatma metnİnde belİrtİldİğİ şekİlde kİşİsel verİlerİmİn
                  saklanmasına, İşlenmesİne ve{" "}
                  <br className="hidden lg:block" /> tarafımla İletİşİme
                  geçİlmesİne İzİn verİyorum.
                </p>
              </div>
            </div>
            <div className="flex justify-end">
              <button
                style={{ fontFamily: "Gotham" }}
                className="min-w-[205px] text-[27px] font-bold text-[#244C5A] bg-[url('../../assets/images/submitbtn.png')] bg-contain bg-center bg-no-repeat px-10 pt-5 pb-6 hover:text-white"
                type="submit"
              >
                {uploading ? (
                  <div
                    class="spinner-border animate-spin inline-block w-8 h-8 border-4 rounded-full"
                    role="status"
                  >
                    <span class="visually-hidden">Loading...</span>
                  </div>
                ) : (
                  "GÖNDER"
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ApplicationForm;
